import { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { fetchPuntoServicio, 
  IfetchPuntoServicio,
  fetchObjetivos,
  IObjetivos,
  fetchObjetivosPorItemId,
  IObjetivosItems,
  fetchIniciarFiscalizacion,
} from "../services/Fiscalizacion/Fiscalizacion";
import {
  IonContent,
  IonPage,
  IonButton,
  IonIcon,
  IonInput,
  IonItem,
  IonCard,
  IonSelect,
  IonSelectOption,
  useIonToast,

} from "@ionic/react";
import { medicalOutline, search } from 'ionicons/icons';
import Header from "../../src/components/Header";
import "./Fiscalizacion.css";
import React from "react";
import Tooltip from '@material-ui/core/Tooltip';
import { useFiscalizacion } from "src/components/Fiscalizacion/FiscalizacionContext";


const Fiscalizacion: React.FC = ({ history, ...restProps }:any) => {
  const { setPuntoServicioFiscaliacion } = useFiscalizacion();
  const [searchValue, setSearchValue] = useState('');
  const [puntosDeServicio, setPuntosDeServicio] = useState<IfetchPuntoServicio[]>([]);
  const [objetivos, setObjetivos] = useState<IObjetivos[]>([]);
  const [objetivosItemsPorPunto, setObjetivosItemsPorPunto] = useState<Record<number, IObjetivosItems[]>>({});
  const [objetivosPorEmpresa, setObjetivosPorEmpresa] = useState({});
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [errorMessagePresent, setErrorMessagePresent] = useState<string | undefined>(undefined);

 

  const [present] = useIonToast();

  const iniciarFiscalizacion = async (punto:IfetchPuntoServicio) => {

    const objetivoIDporEmpresa = Object.values(objetivosPorEmpresa)[0];
    const puntoservicio_id = punto.id;
    const nombre_ps = punto.ps_nombre;
    const objeto = punto.objeto;
    const codigo = punto.ps_codigo;
    setPuntoServicioFiscaliacion(codigo)
    if (puntoservicio_id) {  
      const resultado = await fetchIniciarFiscalizacion(puntoservicio_id, objetivoIDporEmpresa as number );

      if (resultado.error) {
        present(resultado.error, 6000);
        console.error('Error al iniciar la fiscalización:', resultado.error);

      } else {
        history.push(`/fiscalizarinicio/${puntoservicio_id}/${nombre_ps}/${objeto}`);
      }
    }
  };
  
  const continuarFiscalizacion = async (punto:IfetchPuntoServicio) => {

    const puntoservicio_id = punto.id;
    const nombre_ps = punto.ps_nombre;
    const codigo = punto.ps_codigo;
    setPuntoServicioFiscaliacion(codigo)
    history.push(`/fiscalizarinicio/${puntoservicio_id}/${nombre_ps}/${codigo}`);
  };
  
  useEffect(() => {
    const cargarPuntosDeServicio = async () => {

      if (searchValue.length < 3) {
        setErrorMessage(undefined); 
        setPuntosDeServicio([]); 
        return
      }
  
      const resultado = await fetchPuntoServicio(searchValue);
      if (!resultado.error) {
        setErrorMessage(undefined);
        setPuntosDeServicio(resultado.datos);
      } else {
        setErrorMessage(resultado.error);
        console.error('Error al cargar puntos de servicio:', resultado.error);
        setPuntosDeServicio([]);
      }
    };  
    cargarPuntosDeServicio();
  }, [searchValue]); 

  useEffect(() => { 
    const cargarObjetivos = async () => {
      const resultado = await fetchObjetivos();
      if (!resultado.error) {
        setObjetivos(resultado.datos);
      } else {
        setErrorMessagePresent(resultado.error);
        console.error('Error al cargar los objetivos:', resultado.error);
      }
    };
    cargarObjetivos();
  }, []);

  useEffect(() => {
    if (errorMessagePresent) {
      present(errorMessagePresent, 6000);
      setErrorMessagePresent(undefined);
    }
  }, [errorMessagePresent, present]);

  const cargarObjetivosItems = async (itemId:number, puntoId?: number) => {
    const resultado = await fetchObjetivosPorItemId(itemId);
    if (!resultado.error) {
      setObjetivosItemsPorPunto(prevState => ({
        ...prevState,
        [puntoId || 0]: resultado.datos
      }));
    } else {
      present(resultado.error, 6000);
      console.error('Error al cargar los items del objetivo:', resultado.error);
    }
  };

  const handleSelectObjetivo = (idEmpresa: number, objetivo: string) => {
    cargarObjetivosItems(parseInt(objetivo));
    setObjetivosPorEmpresa({
      [idEmpresa]: objetivo
    });
  };
  
  return (
    <IonPage>
      <Header titulo="Fiscalización" />
      <IonContent id="fiscalizacion">
        <div className="fiscalizacion-titles">
        <IonItem>
          <IonInput
            clearInput={true}
            value={searchValue ?? ''}
            placeholder="Escriba al menos 3 letras para iniciar la búsqueda"
            onIonChange={(e) => setSearchValue(e.detail.value ?? '')}
          ></IonInput>
          <IonIcon icon={search} />
        </IonItem>
        </div>

        <div className="fisContainer">

          {searchValue.length < 3 && (
            <div className="fiscalizaciones">
              <p>Realiza la búsqueda de un punto de servicio para fiscalizar alguno de estos aspectos.</p>
              <div className="fisRow">
                <IonCard className="fiscalizacion_btn">
                        <img src="assets/icon/fisc-COD1.svg" alt="personal" />
                        <h3>Personal</h3>
                </IonCard>
                <IonCard className="fiscalizacion_btn ">
                        <img src="assets/icon/fisc-COD2.svg" alt="personal" />
                        <h3>Deposito</h3>
                </IonCard>
                <IonCard className="fiscalizacion_btn ">
                        <img src="assets/icon/fisc-COD3.svg" alt="personal" />
                        <h3>Maquinas</h3>
                </IonCard>
              </div>
              <div className="fisRow">
                <IonCard className="fiscalizacion_btn ">
                        <img src="assets/icon/fisc-COD4.svg" alt="personal" />
                        <h3>Nivel de Limpieza General</h3>
                </IonCard>
                <IonCard className="fiscalizacion_btn ">
                        <img src="assets/icon/fisc-COD5.svg" alt="personal" />
                        <h3>Opinion del Cliente</h3>
                </IonCard>
                <IonCard className="fiscalizacion_btn ">
                        <img src="assets/icon/fisc-COD6.svg" alt="personal" />
                        <h3>Stock de productos</h3>
                </IonCard>
              </div>
            </div>
          )}

          {errorMessage ? (
              <div className="fiscalizaciones">
                <h5>{errorMessage}</h5>
              </div>
            ) : searchValue.length < 3 ? null : puntosDeServicio.length === 0 ? (
              <div className="fiscalizaciones">
                <h5>{`No se encontraron puntos de servicio con el filtro "${searchValue}"`}</h5>
              </div>
              //se utiliza index en el mapeo de puntoDeServicio para evitar warning de "keys" duplicadas, evitamos al tomar el index de cada registro.
            ) : puntosDeServicio.map((punto, index) => ( 
              <IonCard className="fisCard" key={index}>
                <h2>{punto.ps_nombre}</h2>
                <h4>{punto.objeto}</h4>

                {punto.estado === 0 && (
                  <>
                  <IonIcon color="danger" icon={medicalOutline} />
                    <IonSelect
                      onIonChange={(e) => handleSelectObjetivo(punto.id, e.detail.value)}
                      placeholder="Selecciona un objetivo de fiscalización"
                      interface="action-sheet"
                      
                      value={objetivosPorEmpresa[punto.id]}
                      style={{border: '1px solid #21130d', placeholderCSSize: '1.5rem',  placeholderColor: '#21130d',  placeholderFontSize: '1.2rem',  color: 'black', fontSize: '1.4rem', fontWeight: 'bold', background: 'rgba(150, 150, 148, 0.2)'}}>
                      {objetivos.map((objetivo) => (
                        <IonSelectOption key={objetivo.id} value={objetivo.id}>{objetivo.objetivos}</IonSelectOption>
                      ))}
                    </IonSelect>

                    <div className="fiscalizaciones small">
                    { objetivosItemsPorPunto[punto.id]?.map((item) => (
                      <div key={item.id} className="fiscalizacion_btn">
                        <img
                          src={`assets/icon/fisc-${item.codigo}.svg`}
                          alt={
                            item.id === 4
                              ? 'Nivel de Limpieza General'
                              : item.id === 5
                              ? 'Opinion del Cliente'
                              : item.opcion
                          }
                        />
                        <h3>
                          {item.id === 4
                            ? 'Nivel de Limpieza General'
                            : item.id === 5
                            ? 'Opinion del Cliente'
                            : item.opcion}
                        </h3>
                      </div>
                    ))}
                    </div>
                  </>
                )}

                <div className="fisCard_foot--end">

                {punto.estado === 0 ? (
        <Tooltip
          title="No puedes iniciar la fiscalización DEBE ELEGIR UN OBJETIVO"
          disableHoverListener={objetivosPorEmpresa[punto.id]}  // Deshabilita el tooltip solo si el botón no está deshabilitado
        >
          <span>
            <IonButton
              onClick={() => iniciarFiscalizacion(punto)}
              disabled={!objetivosPorEmpresa[punto.id]}
              id="tooltipFis"
              shape='round'
              expand="block"
            >
              INICIAR FISCALIZACIÓN
            </IonButton>
          </span>
        </Tooltip>
      ) : (
        <IonButton
          onClick={() => continuarFiscalizacion(punto)}
          expand="block"
        >
          CONTINUAR FISCALIZACIÓN
        </IonButton>
      )}
                </div>
              </IonCard>
            ))
          }

        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(Fiscalizacion);
